import React from 'react';
import ClientPerformanceStatContainer from '../../containers/clientPerformanceStat/ClientPerformanceStatContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const ClientPerformanceStatPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="경영정보/고객실적현황" icon="partner" />
      <ClientPerformanceStatContainer />
    </>
  );
};

export default ClientPerformanceStatPage;
